import { Badge } from "@chakra-ui/react";

/**
 * Overdue, as a tab on a card's border, as "Your turn" is on a step: the frame
 * and its label are one mark. The one state somebody must not scroll past.
 *
 * The card needs `position="relative"` and `overdueFrame(overdue)`, and room
 * above its first line (`pt={5}` on a `p={4}` body) on every card, overdue or
 * not, so the tab never pushes a title down.
 */
export function OverdueTab() {
  return (
    <Badge
      position="absolute"
      top="-2px"
      left="-2px"
      colorPalette="red"
      variant="solid"
      // Rounded only where it meets the card's corner.
      borderRadius="0"
      borderTopLeftRadius="l3"
      px={2.5}
      py={1}
    >
      Overdue
    </Badge>
  );
}

/**
 * The border of a card that may be overdue. The second pixel of an overdue
 * border is a shadow outside it, so the content does not move by the width a
 * 2px border would add.
 */
export function overdueFrame(overdue: boolean) {
  return {
    borderWidth: "1px",
    borderColor: overdue ? "red.solid" : "border",
    boxShadow: overdue ? "0 0 0 1px var(--chakra-colors-red-solid)" : undefined,
    _hover: { borderColor: overdue ? "red.solid" : "blue.400" },
  } as const;
}
